module.exports = "<p><span style=\"margin-right: 2px\" ng-click=fetch() ng-repeat=\"item in counts\" class=\"label label-default\">{{ item.count }} {{ item._id }}</span> <i ng-if=showSpinner class=\"fa fa-spinner fa-spin fa-fw\"></i></p>";
